import { useState } from "react";
import Modal from "../../components/common/Modal";
import CrudForm from "../../components/common/crud/CrudForm";
import lotService from "../../services/lotService";
import alertService from "../../utils/alertService";
import { normalizeApiError } from "../../utils/apiError";

const lotFormSchema = [
  {
    name: "lotNo",
    label: "Lot Number",
    type: "text",
    placeholder: "e.g. LOT-001",
    validation: {
      required: true,
      minLength: 2,
      maxLength: 100,
    },
  },
  {
    name: "isActive",
    label: "Active",
    type: "checkbox",
    initialValue: true,
  },
];

function LotCreateModal({ isOpen, onClose, onSuccess }) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    setIsSubmitting(true);
    try {
      const result = await lotService.createLot(values);
      alertService.success("Lot created successfully.");
      onSuccess?.(result);
      onClose();
    } catch (err) {
      alertService.error(normalizeApiError(err).message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Add New Lot">
      <CrudForm
        mode="create"
        schema={lotFormSchema}
        initialValues={{ isActive: true }}
        isSubmitting={isSubmitting}
        onSubmit={handleSubmit}
        onCancel={onClose}
      />
    </Modal>
  );
}

export default LotCreateModal;
